import React, { Component } from 'react';
import {connect} from "react-redux";
import { TimePicker } from "antd";
import moment from "moment";

import Context from "../../../../../context/Context";
import Icons from "../../../../util/Icons";
import SpaceFilters from "./SpaceFilters";
import SpaceTypeDropdown from './SpaceTypeDropdown';
import AreaDropdown from './AreaDropdown';
import Button from '../../../../../common/components/Button';
import Rdx from '../../../../../redux/Rdx';
import Calendar from '../../../../common/Calendar/Calendar';
import * as component from "../../../../util/component";

// MSAL Authentication
import { getAccessToken, getBookingSchedule } from "./OfficeHotelingInterface";
import Office365 from "./Office365";
import { ModalController } from '../../../../../common/components/Modal';
import DurationFilters from './DurationFilters';
import Loader from 'calcite-react/Loader/Loader';
import Topic from '../../../../../context/Topic';

const CSS = {
    popoutInner: "i-popout-inner i-filter-popup",
    popoutOuter: "i-popout-outer",
    panelHeader: "i-infopanel-header i-panel-header",
    panelHeaderTools: "i-panel-header-tools",
    filterForm: "i-filter-form",
    toggleAllDay: "i-toggle-all-day",
    toggleLabel: "i-toggle-label",
    durationFilter: "i-duration-filter",
    durationGroup: "i-duration-group",
    durationDate: "i-date",
    durationTime: "i-time",
    iconContainer: "i-sidebar-icon-container i-filter-container",
    icon: "i-more-menu-icon",
    spaceFilters: "i-space-filter",
    button: "i-book-button",
    dateString: "i-date-string",
    sidebarPanelOpen: "i-sidebar-panel-open",
  };

class FilterPopup extends Component {
  accessToken
  format = "h:mm A"
  keys = {
    checkInDate: "checkInDate",
    checkInString: "checkInString",
    checkOutDate: "checkOutDate",
    checkOutString: "checkOutString"
  }
  _mounted = false

  constructor(props) {
    super(props)
    this.state = component.newState({
      isWorking: true,
      noData: false,
      spaceTypeFilters: [],
      areaFilters: []
    })
    this.closeRef = React.createRef()
    this.titleRef = React.createRef()
    this.bookingSystem = Office365.getInstance()
  }

  getBookingSchedule = async (token) => {
    if (token) {
      try {
        const user = await getBookingSchedule(this.bookingSystem, token)
        // console.log(user)
      } catch (e) {
        console.log(e)
      }
    }
  }

  componentWillUnmount() {
    this._mounted = false
    component.componentWillUnmount(this)
  }

  componentDidMount() {
    this._mounted = true
    console.log("MOUNTED")
    this._focus()
    const i18n = Context.instance.i18n
    if (Context.instance.hotelingUnits) {
      Context.instance.hotelingUnits.then(units => {
        if (Context.instance.areas) {
          Context.instance.areas.then(areas => {
            // console.log(units)
            // console.log(areas)
            let spaceTypeFilters = []
            units.forEach(unit => {
              const spaceType = unit.attributes.USE_TYPE || unit.attributes.use_type
              if (!spaceTypeFilters.includes(spaceType)) spaceTypeFilters.push(spaceType)
            })
            let areaFilters = []
            areas.forEach(area => {
              const name = area.attributes.AREA_NAME || area.attributes.area_name
              if (!areaFilters.includes(name)) areaFilters.push(name)
            })
            this.setState({
              isWorking: false,
              spaceTypeFilters: spaceTypeFilters,
              areaFilters: areaFilters
            })
          }).catch(error => {
            this.setState({
              isWorking: false,
              spaceTypeFilters: [],
              areaFilters: [],
              noData: true
            })
            console.error(error)
            ModalController.showMessage(i18n.more.bookWorkspace.invalidData)
          })
        } else {
          this.setState({
            isWorking: false,
            spaceTypeFilters: [],
            areaFilters: [],
            noData: true
          })
          ModalController.showMessage(i18n.more.bookWorkspace.missingAreas)
        }
      }).catch(error => {
        this.setState({
          isWorking: false,
          spaceTypeFilters: [],
          areaFilters: [],
          noData: true
        })
        console.error(error)
        ModalController.showMessage(i18n.more.bookWorkspace.invalidData)
      })
      component.own(this, [
        Topic.subscribe(Topic.BookingFiltersSet, params => {
          if (this._mounted) {
            if (typeof this.props.closePopup === "function") this.props.closePopup()
            if (this.props.rdxSidebarActiveKey !== "bookWorkspace") {
              Rdx.setValue(this, Rdx.Keys.SIDEBAR_ACTIVE_KEY, "bookWorkspace");
              document.body.classList.add(CSS.sidebarPanelOpen);
              Topic.publish(Topic.SidebarButtonClicked, {sidebarKey: "bookWorkspace"});
              Context.instance.views.toggleClickHandlers("resume");
            }

            setTimeout(function() {
              Topic.publish(Topic.BookingFiltersSubmit, {})
            }, 100)
          }
        })
      ])
    } else {
      this.setState({
        isWorking: false,
        spaceTypeFilters: [],
        areaFilters: [],
        noData: true
      })
      ModalController.showMessage(i18n.more.bookWorkspace.missingUnits)
    }
  }

  componentDidUpdate() {
    if (!this.state.noData && !this.state.isWorking) {
      this._focus()
    }
  }

  _focus() {
    if (this.titleRef && this.titleRef.current && this.titleRef.current.focus) {
      this.titleRef.current.focus()
    }
  }

  onSubmit = () => {
    if (this._mounted) {
      Topic.publish(Topic.DurationFiltersSet, {})
    }
  }

  render() {
    const i18n = Context.instance.i18n

    if (this.state.noData) {
      return null
    } else if (this.state.isWorking) {
      return (
        <div className={CSS.popoutOuter}>
          <Loader sizeRatio={2} />
        </div>
      )
    } else {
      return (
        <div className={CSS.popoutOuter}>
          <div className={CSS.popoutInner}>
            <div className={CSS.panelHeader}>
              <h2 tabIndex="0" ref={this.titleRef}>{i18n.more.bookWorkspace.popupTitle}</h2>
              <div className={CSS.panelHeaderTools}>
                <button ref={this.closeRef}
                  title={i18n.general.close} aria-label={i18n.more.bookWorkspace.closeAriaLabelInit}
                  tabIndex="0" onClick={this.props.closePopup}>
                  {Icons.close()}
                </button>
              </div>
            </div>
            <div className={CSS.filterForm}>
              <DurationFilters initialFilter={true} />
              <SpaceFilters 
                initialFilter={true} 
                spaceTypeFilters={this.state.spaceTypeFilters} 
                areaFilters={this.state.areaFilters} />
            </div>
            <div className={CSS.button}>
                <Button type="button" onClick={this.onSubmit}>{i18n.general.done}</Button>
            </div> 
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    rdxStartDateSelected: Rdx.getValue(state, Rdx.Keys.BOOK_DATEFILTER_STARTSELECTED),
    rdxEndDateSelected: Rdx.getValue(state, Rdx.Keys.BOOK_DATEFILTER_ENDSELECTED),
    rdxStartTimeSelected: Rdx.getValue(state, Rdx.Keys.BOOK_TIMEFILTER_STARTSELECTED),
    rdxEndTimeSelected: Rdx.getValue(state, Rdx.Keys.BOOK_TIMEFILTER_ENDSELECTED),
    rdxAllDayChecked: Rdx.getValue(state, Rdx.Keys.BOOK_ALLDAY),
    rdxSidebarActiveKey: Rdx.getValue(state, Rdx.Keys.SIDEBAR_ACTIVE_KEY)
  }
}

export default connect(mapStateToProps)(FilterPopup);